var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import DrawerRoot from './src/DrawerRoot';
import Header from './src/Header';
import Content from './src/Content';
import Footer from './src/Footer';
var Drawer = function (props) {
    var open = props.open, title = props.title, anchor = props.anchor, children = props.children, onOk = props.onOk, onClose = props.onClose, onBack = props.onBack, okText = props.okText, closeText = props.closeText, okProps = props.okProps, closeProps = props.closeProps, footer = props.footer, header = props.header, isShowClose = props.isShowClose, BackdropProps = props.BackdropProps, isBackdrop = props.isBackdrop;
    var isNullFooter = footer === null;
    return (React.createElement(DrawerRoot, { open: open, anchor: anchor, onClose: onClose, BackdropProps: __assign({ open: isBackdrop === true }, BackdropProps) },
        React.createElement(Content, { isNullFooter: isNullFooter },
            React.createElement(Header, { header: header, title: title, isShowClose: isShowClose, onBack: onBack, onClose: onClose }),
            children),
        React.createElement(Footer, { footer: footer, onOk: onOk, onClose: onClose, okText: okText, closeText: closeText, okProps: okProps, closeProps: closeProps })));
};
Drawer.defaultProps = {
    open: false,
    anchor: 'right',
    isShowClose: true,
    isBackdrop: true,
};
export default Drawer;
